import { accountApi } from 'Application/Account/services/api'
import {
  ACCOUNT_CACHE_STORE,
  ACCOUNT_DB_STORE,
} from 'Application/Account/services/api/account.config'
import { notificationApi } from 'Application/Notification/services/api'
import {
  NOTIF_CACHE_STORE,
  NOTIF_DB_STORE,
} from 'Application/Notification/services/api/notification/notification.config'
import { clearAllCache } from 'DataBase/rtk-persist/cache'
// import { uploadsApi, visitsApi } from 'Application/Visits/services/api'
import { commonApi } from 'Services/api'
import { COMMON_CACHE_STORE, COMMON_DB_STORE } from 'Services/api/common/common.config'
import store from 'Store'

export const resetApiStates = () => {
  store.dispatch(commonApi.util.resetApiState())
  store.dispatch(accountApi.util.resetApiState())
  store.dispatch(notificationApi.util.resetApiState())

  // store.dispatch(visitsApi.util.resetApiState())
  // store.dispatch(uploadsApi.util.resetApiState())
}

export const clearApiStates = async () => {
  await clearAllCache(COMMON_DB_STORE, COMMON_CACHE_STORE)
  await clearAllCache(NOTIF_DB_STORE, NOTIF_CACHE_STORE)
  await clearAllCache(ACCOUNT_DB_STORE, ACCOUNT_CACHE_STORE)
}
